<template>
  <div class="container">
    <p class="h2">服务协议</p>
    <p>甲    方：北京拉勾网络技术有限公司</p>
    <p>乙    方：拉勾教育高薪Offer特训营课程学员</p>
    <p class="txt mr-t-24">甲乙双方经友好协商，就乙方购买甲方培训服务达成如下培训协议：</p>
    <p class="title mr-t-24">第一条 服务内容及费用</p>
    <p class="txt">1.1 课程内容：《高薪Offer特训营》（具体课程名称及技能方向以实际购买内容为准），课程详细内容以具体页面的课程介绍及相关公告为准。</p>
    <p class="txt">1.2 服务期：6个月。</p>
    <p class="txt">1.3 培训形式：提供课程直播+录播、答疑、就业指导等服务。对于符合条件的学员，还可提供就业推荐服务（乙方在一年内完成课程学习、即课程每个阶段学习观看进度达100%的前提下，甲方将乙方简历推荐至用人单位）。其中课程学习时长约为3个月至4.5个月（根据所购买具体课程的不同而有所浮动），答疑服务有效期为6个月。就业指导及内推服务有效期为入班后一年。</p>
    <p class="txt">1.4 服务费：以最终实际支付费用金额为准</p>
    <p class="txt">1.5 发票：乙方支付服务费且无理由退款期届满后，根据乙方申请，甲方可开具增值税发票。</p>
    <p class="title mr-t-24">第二条 甲方的权利与义务</p>
    <p class="txt">2.1 甲方确保教学计划顺利进行，并提供相应的教学服务，在教学进程中，如有必要进行课程调整，须提前通知乙方。</p>
    <p class="txt">2.2 对乙方的个人信息负有保密义务。</p>
    <p class="txt">2.3 甲方保证在线学习系统所提供的各项功能、服务均能够正常使用。若因不可抗力因素以及乙方原因造成不能正常使用甲方在线学习系统所提供的各项服务，包括但不限于互联网运营商提供的网络中断、乙方不具备上网条件（包括不具备软硬件条件或者出现软硬件故障）等，则甲方不承担相应责任。</p>
    <p class="title mr-t-24">第三条 乙方的权利与义务</p>
    <p class="txt">3.1 乙方须按要求支付服务费用，方可进行学习，根据甲方需求提供详细个人资料并确保资料真实有效。</p>
    <p class="txt underline">3.2 乙方不得在购买课程后将账号密码与他人共享或再次出售，不得进行翻录、转播等盗版等侵权行为。甲方发现乙方侵权行为或有合理理由怀疑乙方存在侵权行为的（包括但不限于甲方通过数据监控发现乙方账号存在账号异常的情形如：短时间内频繁异地/不同设备登录、非以学习为目的购买服务干扰正常教学秩序等）有权进行封号、暂停/永久停止服务处理等措施。因此类情况导致乙方无法继续享受服务的，甲方有权不予退还任何服务费并要求乙方支付合同金额的10倍或违法所得的10倍做违约金（以高者为准）；甲方保留采取进一步法律措施的权利。</p>
    <p class="txt">3.3 在正常教学指导过程中，甲方有权对乙方进行统一学习规范及进度管理，并要求乙方服从甲方指定的相关学习规范和学习管理制度；乙方购买课程后视为认可并愿意服从甲方指定的规范和制度管理，并接受甲方制度中对应的规定。</p>
    <p class="txt">3.4 乙方对甲方的教学计划、教学视频、课件、内部资料、各类试题、教学服务细节等信息负有保密义务，不得向其他任何第三方透露以上内容，否则应赔偿给甲方造成的损失，承担相应的法律责任。</p>
    <p class="txt">3.5 乙方完成费用支付后，应在协议约定时间内学习课程，甲方按约定提供教学服务；<span class="underline">如乙方中途退学视为自愿放弃甲方培训服务，且甲方有权不予退还任何服务费用。</span></p>
    <p class="txt underline oblique bold">3.6 乙方在入班后一年内未达到本协议1.3条约定的内推服务要求的，视为乙方放弃内推服务权利，甲方不就此承担任何责任。</p>
    <p class="title mr-t-24">第四条 退费条款</p>
    <p class="txt">4.1 遇到以下情况，乙方可申请退款，退款后甲方停止为乙方提供课程及后续服务：</p>
    <p class="txt bold">4.1.1 乙方自购买之日起，开课后 7个自然日内对课程或服务不满意的，可享受无理由退款（“无理由退款期”）；开课7个自然日后不享受无理由退款。</p>
    <p class="txt">4.1.2 退款申请通过后，甲方将按原价扣除甲方为乙方提供的优惠券、赠品、书籍、服务等对应金额后退还剩余款项。</p>
    <p class="txt">4.2 如乙方选择第三方银行或金融信贷机构消费贷、教育贷或分期付款等方式支付培训服务费，乙方与第三方银行或金融信贷机构企业发生的业务关系，是乙方与第三方企业之间的独立业务关系；若乙方与第三方企业发生法律纠纷，与甲方无关。</p>
    <p class="txt">4.3 乙方严重违反甲方管理规定的，甲方将终止提供服务，且不退还任何费用。</p>
    <p class="title mr-t-24">第五条 不可抗力</p>
    <p class="txt">5.1 不可抗力指超出本协议双方控制范围，无法预见，无法避免或无法克服，使得本协议一方或双方部分或者全部不能履行本协议的事件。这类事件包括但不限于地震，台风，洪水，火灾，战争，罢工，暴动，政府行为，电脑病毒，黑客攻击，网络故障，带宽或其他电信、网络设备或技术提供商的服务延迟、服务障碍或任何其他类似事件，法律规定或其适用的变化，或者其他任何无法预见、避免或者控制的事件。</p>
    <p class="txt">5.2 如果任何一方因不可抗力而无法履行或迟延履行本协议规定的义务，则该方免除承担违约责任。</p>
    <p class="txt">5.3 在不可抗力因素消除后，曾受不可抗力因素影响而未能履约的一方应尽最大努力恢复履行其在本协议项下的义务。</p>
    <p class="txt">5.4 乙方出国、外派、怀孕、更改职业规划等不视为不可抗力。</p>
    <p class="title mr-t-24">第六条 其他</p>
    <p class="txt">6.1 本协议的订立，执行和解释及争议的解决均适用于中国法律。</p>
    <p class="txt">6.2 双方在履行本协议的过程中，如发生任何争议，则双方应首先进行友好协商。</p>
    <p class="txt">6.3 如果某一争议未能在一方首次提出协商之日后30日内通过友好协商解决，则任何一方可将该争议提交甲方所在地法院诉讼解决。</p>
    <p class="txt bold">6.4 凡购买本协议项下《高薪Offer特训营》课程视为同意签署本协议。本协议自乙方购买本协议下相应课程并成功付费后生效。</p>
  </div>
</template>
<script>
export default {
  name: "docH5",

  data() {
    return {

    };
  },
  methods: {

  },
};
</script>
<style lang='less' scoped>
.container {
  overflow-y: auto;
  padding: 32px;
  box-sizing: border-box;
}
.h2 {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 32px;
}
p {
  font-size: 28px;
  margin-bottom: 8px;
}
.mr-t-24 {
  margin-top: 20px;
}
.title {
  font-weight: bold;
}
.txt {
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.oblique {
  font-style: oblique;
}
.bold {
  font-weight: bold;
}

</style>
